export default __webpack_public_path__ + "static/media/mangodb.5f6bad00.png";